export default __webpack_public_path__ + "static/mehrstufig-live-national-2aa66e10067e5be4f7763957fba968a2.jpg";